"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var typeChecks_1 = require("../../utils/typeChecks");

var ParseTransform =
/** @class */
function (_super) {
  __extends(ParseTransform, _super);

  function ParseTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ParseTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;

    try {
      var parseTransformOptions = this.options.parseTransformOptions;

      if (parseTransformOptions) {
        var _a = parseTransformOptions.type,
            type = _a === void 0 ? "string" : _a;

        if (!typeChecks_1.isNullOrUndefined(queryResponse) && type) {
          switch (type) {
            case 'float':
              response = parseFloat(response);
              break;

            case 'integer':
              response = parseInt(response);
              break;

            case 'string':
              response = response.toString();
              break;

            default:
              break;
          }
        }
      }
    } catch (ex) {
      console.warn("Error in ParseTransform: ", {
        queryResponse: queryResponse,
        options: this.options
      }, ex);
    }

    return response;
  };

  return ParseTransform;
}(BaseTransform_1.BaseTransform);

exports.ParseTransform = ParseTransform;